import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import Link from 'flarum/common/components/Link';

import { currentPath, N8N_TAG_SLUG } from './utils/routeState';
import { hasN8nAccess } from './utils/requestForm';
import { proposePath } from './utils/proposeForm';

/**
 * «Proponer un encuentro» en el sidebar de la categoría de n8n Chile.
 *
 * SE MUDÓ, no se creó (PKG-FORO-PRODUCT-GATES · decisión C). Esta tarjeta vivía en el sidebar
 * de `/t/encuentros`, la categoría ABIERTA, con un comentario que decía «NO SE OCULTA AL
 * INVITADO» — coherente con la decisión de T11 y contraria a la de hoy: proponer un encuentro
 * sale de la comunidad abierta y pasa a n8n Chile, que es quien los organiza.
 *
 * DOS CONDICIONES, Y HACEN FALTA LAS DOS:
 *
 *   - estar EN la categoría del grupo (`/t/n8n-chile`). Se comprueba la ruta y no la etiqueta
 *     activa de la store porque `IndexPage.sidebarItems` se rinde también en `/discusiones`,
 *     donde no hay ninguna;
 *   - y tener el acceso (`hasN8nAccess()`). Es un cinturón sobre otro: a esa URL sólo llega
 *     quien ve la etiqueta restringida —al resto le responde 404— pero un admin la ve sin
 *     pertenecer al grupo, y ofrecerle proponer desde ahí es correcto y no accidental.
 *
 * La OTRA superficie de proponer es `N8nChilePage`, la página pública del grupo, donde el
 * bloque se pinta sólo para miembros. Las dos comparten el copy (`forum.propose_card.*`) y la
 * misma sonda, para que no puedan divergir.
 *
 * Prioridad -15: por debajo de la lista de categorías (`nav`, que `collapsibleSidebar` deja en
 * -10) y por encima de la n8card (-20), que en esta pantalla es la que menos aporta.
 */
export default function addProposeCta() {
  extend(IndexPage.prototype, 'sidebarItems', function (items: any) {
    if (currentPath() !== app.route('tag', { tags: N8N_TAG_SLUG })) return;
    if (!hasN8nAccess()) return;

    const t = (key: string) => app.translator.trans('umbral-comunidad.forum.propose_card.' + key);

    items.add(
      'umbralProposeCta',
      <div className="CmProposeCard" data-cm-propose-card="1">
        <h3>{t('title')}</h3>
        <p>{t('body')}</p>
        <Link className="Button Button--primary CmProposeCard-cta" href={proposePath()}>
          {t('cta')}
        </Link>
      </div>,
      -15
    );
  });
}
